import React from 'react';
export function BookingBanner() {
  return <section className="w-full py-24 px-4 bg-background border-y border-[#222222]" data-id="element-10">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-11">
        <h2 className="font-display text-5xl md:text-7xl font-bold text-gold uppercase tracking-wide mb-10" data-id="element-12">
          ¿Listo para tu corte?
        </h2>
        <a href="https://book.weibook.co/branch/pueblo-barber-sede-1" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-hover text-background font-display text-2xl md:text-3xl font-bold py-6 px-12 rounded uppercase tracking-widest transition-colors w-full sm:w-auto" data-id="element-13">
          Reserva Ahora
        </a>
      </div>
    </section>;
}